import { PayslipGenerationMode } from '@jaam/commons/constants';
import { CompanyDto } from '@jaam/commons/dtos';
import { atom } from 'recoil';

interface CompaniesState {
  companies: CompanyDto[];
  activeCompany?: CompanyDto | null;
  role?: string;
  permissions: string[];
  createWithModal: boolean;
  create: boolean;
  manualPayPeriodEditorsEmails: string[];
  payslipGenerationMode: PayslipGenerationMode;
}

const defaultCompanyState: CompaniesState = {
  companies: [],
  activeCompany: null,
  role: undefined,
  permissions: [],
  createWithModal: false,
  create: false,
  manualPayPeriodEditorsEmails: [],
  payslipGenerationMode: PayslipGenerationMode.AUTOMATIC,
};

export const companyState = atom<CompaniesState>({
  key: 'companyState',
  default: defaultCompanyState,
});
